/** Keep in sync with backend config/auth_tokens.php (AUTH_TOKEN_COOKIE). */
const LEGACY_KEY = 'hrms_token';

export const AUTH_TOKEN_KEY =
  (import.meta.env.VITE_AUTH_TOKEN_KEY ?? '').trim() || 'hrms_api_token';

export function readStoredToken(): string | null {
  const session = sessionStorage.getItem(AUTH_TOKEN_KEY);
  if (session) return session;

  const current = localStorage.getItem(AUTH_TOKEN_KEY);
  if (current) return current;

  const legacy = localStorage.getItem(LEGACY_KEY);
  if (legacy) {
    localStorage.setItem(AUTH_TOKEN_KEY, legacy);
    localStorage.removeItem(LEGACY_KEY);
    return legacy;
  }

  return null;
}

/** remember=false keeps the token for this browser session only. */
export function writeStoredToken(token: string, remember = true): void {
  if (remember) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
  } else {
    sessionStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }
  localStorage.removeItem(LEGACY_KEY);
}

export function clearStoredToken(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(LEGACY_KEY);
}
